import React, { useEffect, useState, useRef } from "react";
import CommonTable from "@/components/commonTable";
import { Row, Col, Tooltip, Icon } from "antd";
import { Link } from "react-router-dom";
import SearchBox from "./components/searchBox";
import { getJurisdiction } from "@/statics/js/jurisdiction";
import {
  _allOverdueReports,
  _overdueReportsStatistics,
} from "@/statics/js/api";
import "../style.less";
const MonthlyPayment = (props) => {
  const {orderStatusItem} = props
  const tableRef = useRef();
  const [overdueDate, setOverdueDate] = useState({
    overdueOrderCount: 0,
    overdueTotalAmount: 0,
  });
  useEffect(() => {
    let fid =
      localStorage.getItem("type") !== "0" ? localStorage.getItem("fid") : "";
    getOverdueDate({ fid });
  }, []);
  let columns = [
    {
      title: "订单号",
      width: 180,
      dataIndex: "orderSn",
      render: (text) => (
        <Link target="_blank" to={"/packageOrderManagement?orderSn=" + text}>
          {text}
        </Link>
      ),
    },
    {
      title: "商户名",
      width: 160,
      dataIndex: "franchiseeName",
    },
    {
      title: "站点",
      width: 150,
      dataIndex: "siteName",
    },
    {
      title: '订单状态',
      width: 120,
      render: (text) => (
        <span>
          {orderStatusItem[text.orderStatus - 1]?.title}
        </span>
      ),
    },
    {
      title:"是否挂起",
      width: 70,
      dataIndex: "hangUp",
      render: (text) => (text === 0 ? "否" : text === 1 ? "是" : null),
    },
    {
      title: "挂起订单时间",
      width: 100,
      dataIndex: "hangUpTime",
    },
    {
      title: () => (
        <>
          <span>挂起金额</span>&nbsp;
          <Tooltip placement="top" title="挂起时生成的金额，包含月扣逾期租金、日扣逾期租金、逾期租金违约金、退租违约金、维修费、资寻费、资产丢失费等">
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 110,
      dataIndex: "hangUpMoneyFormat",
    },
    {
      title: () => (
        <>
          <span>挂起可代扣金额</span>&nbsp;
          <Tooltip placement="top" title="挂起金额包含的月扣逾期租金、日扣逾期租金、逾期租金违约金、退租违约金可以自动扣款，其他成份金额需用户主动支付">
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 110,
      dataIndex: "hangUpCanPaidAmountFormat",
    },
    {
      title: "挂起已扣金额",
      width: 80,
      dataIndex: "hangUpPaidAmount",
    },
    {
      title: () => (
        <>
          <span>订单逾期开始时间</span>&nbsp;
          <Tooltip placement="top" title="订单逾期时间按合同签约时间计算">
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 110,
      dataIndex: "overdueStartTime",
    },
    {
      title: () => (
        <>
          <span>应收未收逾期金额</span>&nbsp;
          <Tooltip placement="top" title="已到支付时间未支付成功的订单金额">
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 110,
      dataIndex: "unpaidOverdueMoneyFormat",
    },
    {
      title: () => (
        <>
          <span>逾期租金违约金</span>&nbsp;
          <Tooltip
            placement="top"
            title="订单租金逾期后会产生一定费用，每期逾期金额*0.0005*当期逾期天数。多期租金逾期时算出各自逾期租金违约金后相加。"
          >
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 100,
      dataIndex: "diffMoneyFormat",
    },
    {
      title: () => (
        <>
          <span>提前退租违约金</span>&nbsp;
          <Tooltip
            placement="top"
            title="没有支付完合同规定的期数对应的租金，提前退租所缴纳的违约金"
          >
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 100,
      dataIndex: "penaltyMoneyFormat",
    },
    {
      title: "维修费",
      width: 110,
      dataIndex: "repairMoneyFormat",
    },
    {
      title: () => (
        <>
          <span>资寻费</span>&nbsp;
          <Tooltip
            placement="top"
            title="资产找回过程产生的费用，一般包含停车费、拖车费、罚款由商家在挂起订单时填写"
          >
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 100,
      dataIndex: "callCarMoneyFormat",
    },
    {
      title: () => (
        <>
          <span>资产丢失费</span>&nbsp;
          <Tooltip
            placement="top"
            title="用户租用的设备无法归还，用户对商家进行的赔偿，由商家在挂起订单时填写"
          >
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 100,
      dataIndex: "assetsLossMoneyFormat",
    },
    {
      hide: localStorage.getItem("type") !== "0",
      title: "追偿金额",
      width: 100,
      dataIndex: "recourseMoneyFormat",
    },
    {
      title: "套餐名称",
      width: 150,
      dataIndex: "packageName",
    },
    {
      title: "套餐类型",
      width: 90,
      dataIndex: "packagesType",
      render: (text) =>
        text === 1
          ? "租赁"
          : text === 2
          ? "销售"
          : text === 3
          ? "以租代售"
          : text === 4
          ? "连续租赁"
          : null,
    },
    {
      title: "先付/后付",
      width: 100,
      dataIndex: "deductType",
      render: (text) =>
        text === 0 ? "--" : text === 1 ? "先付" : text === 2 ? "后付" : null,
    },
    {
      title: "套餐金额",
      width: 90,
      dataIndex: "packageMoneyFormat",
    },
    {
      title: "合同总期数",
      width: 80,
      dataIndex: "periodsNum",
    },
    {
      title: () => (
        <>
          <span>合同总租金</span>&nbsp;
          <Tooltip placement="top" title="合同总租金=套餐金额*合同总期数">
            <Icon type="question-circle" />
          </Tooltip>
        </>
      ),
      width: 80,
      dataIndex: "rentAmountFormat",
    },
    {
      title: "订单下单时间",
      width: 100,
      dataIndex: "createTime",
    },
    {
      title: "合同租赁开始时间",
      width: 100,
      dataIndex: "leaseStartTime",
    },
    {
      title: "合同租赁结束时间",
      width: 100,
      dataIndex: "leaseEndTime",
    },
    {
      title: "用户姓名",
      width: 90,
      dataIndex: "username",
    },
    {
      title: "手机号",
      width: 110,
      dataIndex: "mobile",
    },
    {
      title: "身份证号码",
      width: 120,
      dataIndex: "idCard",
    },
    {
      title: "数据类型",
      width: 100,
      dataIndex: "errorData",
      render: (text) =>
        text === 0 ? "正常数据" : text === 1 ? "异常数据"  : null,
    },
    {
      title: "电催记录",
      width: 100,
      dataIndex: "urgentCount",
      render: (text, record) =>
        text > 0  ? (
          <Link target="_blank" to={"/electricCollectionReport?orderSn=" + record.orderSn}>
            点击查看
          </Link>
        ) : (
          "--"
        ),
    },
    {
      title: "备注",
      width: 100,
      dataIndex: "remark",
    },
  ];
  columns = columns.filter((item) => !item.hide);
  const getOverdueDate = async ({ fid = "" }) => {
    let params = { fid, type: 4 };
    const res = await _overdueReportsStatistics(params);
    if (res.data.code === 200) {
      setOverdueDate(res.data.data);
    }
  };
  const handleSearch = (params) => {
    tableRef.current.handleSearch(params);
    getOverdueDate({ fid: params.fid });
  };
  return !getJurisdiction(1109) ? (
    "暂无操作权限！"
  ) : (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <div className="centerDiv">
            总逾期订单数（近1年）
            <span>{overdueDate.overdueOrderCount}</span>
            笔
          </div>
        </Col>
        <Col span={12}>
          <div className="centerDiv">
            总逾期金额（近1年）
            <span>{overdueDate.overdueTotalAmountFormat}</span>
            元
          </div>
        </Col>
      </Row>
      <div className="select-form">
        <SearchBox search={handleSearch} orderStatusItem={orderStatusItem} />
      </div>
      <CommonTable
        action={_allOverdueReports}
        showSort
        options={{
          columns: columns,
          scroll: { x: 2500, y: 500 },
        }}
        ref={tableRef}
      />
    </div>
  );
};

export default MonthlyPayment;
